module.exports = __webpack_public_path__ + "static/media/twinkle-color-carousel-3.8e51fcff.png";